import i18n from "./i18n";

function listWeekShort() {
  return [
    i18n.t("common.calendar.sunday"),
    i18n.t("common.calendar.monday"),
    i18n.t("common.calendar.tuesday"),
    i18n.t("common.calendar.wednesday"),
    i18n.t("common.calendar.thursday"),
    i18n.t("common.calendar.friday"),
    i18n.t("common.calendar.saturday"),
  ];
}

export { listWeekShort };
